import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const p=t("algeria",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="white" />
            <path
                d="M0 4.5H12V20.5H0V4.5Z"
                fill="#006633" />
            <path
                d="M15.4641 10.5C15.0238 9.73743 14.3442 9.14145 13.5307 8.80448C12.7172 8.46752 11.8153 8.4084 10.9647 8.6363C10.1142 8.8642 9.36262 9.36638 8.82659 10.065C8.29055 10.7635 8 11.6195 8 12.5C8 13.3805 8.29055 14.2365 8.82659 14.935C9.36262 15.6336 10.1142 16.1358 10.9647 16.3637C11.8153 16.5916 12.7172 16.5325 13.5307 16.1955C14.3442 15.8586 15.0238 15.2626 15.4641 14.5C15.0497 15.0175 14.4849 15.3936 13.8475 15.5762C13.2102 15.7588 12.5319 15.739 11.9063 15.5194C11.2807 15.2998 10.7388 14.8914 10.3554 14.3505C9.97203 13.8096 9.7661 13.163 9.7661 12.5C9.7661 11.837 9.97203 11.1904 10.3554 10.6495C10.7388 10.1086 11.2807 9.70017 11.9063 9.4806C12.5319 9.26102 13.2102 9.24117 13.8475 9.42378C14.4849 9.6064 15.0497 9.98246 15.4641 10.5ZM15.618 12.5L12 11.3244L14.2361 14.4021V10.5979L12 13.6756L15.618 12.5Z"
                fill="#D21034" />
        </svg>
    `),r=t("algeria_rounded",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66543)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-6 0.5H30V24.5H-6V0.5Z"
                    fill="white" />
                <path
                    d="M-6 0.5H12V24.5H-6V0.5Z"
                    fill="#006633" />
                <path
                    d="M17.1962 9.5C16.5358 8.35615 15.5164 7.46218 14.2961 6.95673C13.0758 6.45127 11.7229 6.3626 10.4471 6.70445C9.17129 7.0463 8.04394 7.79957 7.23988 8.84743C6.43583 9.8953 6 11.1792 6 12.5C6 13.8208 6.43583 15.1047 7.23988 16.1526C8.04394 17.2004 9.17129 17.9537 10.4471 18.2956C11.7229 18.6374 13.0758 18.5487 14.2961 18.0433C15.5164 17.5378 16.5358 16.6439 17.1962 15.5C16.5746 16.2763 15.7273 16.8404 14.7713 17.1143C13.8153 17.3882 12.7978 17.3585 11.8594 17.0291C10.9211 16.6997 10.1082 16.0871 9.53312 15.2757C8.95804 14.4644 8.64915 13.4945 8.64915 12.5C8.64915 11.5055 8.95804 10.5356 9.53312 9.72427C10.1082 8.91294 10.9211 8.30026 11.8594 7.9709C12.7978 7.64153 13.8153 7.61176 14.7713 7.88568C15.7273 8.1596 16.5746 8.72369 17.1962 9.5ZM17.4271 12.5L12 10.7366L15.3541 15.3532V9.64684L12 14.2634L17.4271 12.5Z"
                    fill="#D21034" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66543">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as Algeria,r as AlgeriaRounded};
